"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var R = _interopRequireWildcard(require("ramda"));
var _reactDeviceDetect = require("react-device-detect");
var _analytics = require("../../bus/analytics");
var _selectors3 = require("../collections/store/selectors");
var _actions = require("./store/actions");
var _selectors4 = require("./store/selectors");
var _Item = _interopRequireDefault(require("./components/Item"));
var _Hotel = require("./components/Hotel");
var _Offer = require("./components/Offer");
var _PricesMatrix = _interopRequireDefault(require("./components/PricesMatrix"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Result = function Result(_ref) {
  var currency = _ref.currency,
    compact = _ref.compact,
    hotelID = _ref.hotelID,
    offerID = _ref.offerID,
    position = _ref.position,
    queryID = _ref.queryID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var getQueriesIDsForMatrix = (0, _react.useMemo)(function () {
    return (0, _selectors4.createGetQueriesIDsForMatrix)(hotelID);
  }, [hotelID]);
  var queriesIDsForMatrix = (0, _reactRedux.useSelector)(getQueriesIDsForMatrix);
  var isIncludedRootOfferInPriceMatrixOffersSelector = (0, _react.useMemo)(function () {
    return (0, _selectors4.createGetIsIncludedOfferIDInPrices)(queriesIDsForMatrix, offerID);
  }, [offerID, queriesIDsForMatrix]);
  var isIncludedRootOffer = (0, _reactRedux.useSelector)(isIncludedRootOfferInPriceMatrixOffersSelector);
  var isHoveredHotel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors4.getIsHoveredHotel)(state, {
      hotelID: hotelID
    });
  });
  var hotel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getHotel)()(state, hotelID);
  });
  var offerSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors2.getOffer)(), [{
      offerID: offerID
    }]);
  }, [offerID]);
  var offer = (0, _reactRedux.useSelector)(offerSelector);
  var isEnabledCollectionsFeature = (0, _reactRedux.useSelector)(_selectors3.isEnabledCollectionsFeature);
  var handleOpenMap = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.openMapByHotel)(hotelID, offerID, queryID));
  }, [dispatch, hotelID, offerID, queryID]);
  var handleIntersectionOnOfferWrapper = (0, _react.useMemo)(function () {
    return R.once(function () {
      dispatch((0, _analytics.trackViewedOfferAtSearchPage)(offerID, position));
    });
  }, [dispatch, offerID, position]);
  var onMouseEnterItem = (0, _react.useCallback)(function () {
    dispatch((0, _actions.setIsHoveredHotel)(hotelID, true));
  }, [dispatch, hotelID]);
  var onMouseLeaveItem = (0, _react.useCallback)(function () {
    dispatch((0, _actions.setIsHoveredHotel)(hotelID, false));
  }, [dispatch, hotelID]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Item.default, {
    compact: compact,
    price: offer.price[currency.code],
    onIntersection: handleIntersectionOnOfferWrapper,
    onMouseEnter: _reactDeviceDetect.isDesktop ? onMouseEnterItem : undefined,
    onMouseLeave: _reactDeviceDetect.isDesktop ? onMouseLeaveItem : undefined
  }, /*#__PURE__*/_react.default.createElement(_Hotel.HotelWithOfferDetails, {
    averageRating: hotel.averageRating,
    city: hotel.city,
    compact: compact,
    country: hotel.country,
    currency: currency.code,
    district: hotel.district,
    hotelID: hotelID,
    isEnabledCollectionsFeature: isEnabledCollectionsFeature,
    isMobile: _reactDeviceDetect.isMobileOnly,
    isCrossTour: offer.isCrossTour,
    isShowOpenOfferButton: _reactDeviceDetect.isMobile || isHoveredHotel,
    name: hotel.name,
    offerID: offerID,
    photo: hotel.photos[0],
    queryID: queryID,
    secondaryStars: hotel.secondaryStars,
    services: hotel.services,
    sourceRatings: hotel.sourceRatings,
    stars: hotel.stars,
    watermark: hotel.watermark,
    onOpenMap: hotel.location ? handleOpenMap : undefined
  }), /*#__PURE__*/_react.default.createElement(_Offer.Offer, {
    buttons: /*#__PURE__*/_react.default.createElement(_Offer.Buttons, {
      compact: compact,
      hotelID: hotelID,
      isMobile: _reactDeviceDetect.isMobileOnly,
      offerID: offerID,
      queryID: queryID
    }),
    compact: compact,
    isMobile: _reactDeviceDetect.isMobileOnly
  }, /*#__PURE__*/_react.default.createElement(_Offer.Transports, {
    compact: compact,
    date: offer.date,
    flights: offer.flights,
    isMobile: _reactDeviceDetect.isMobileOnly,
    nights: offer.nights,
    nightsInHotel: offer.nightsInHotel,
    transport: offer.transport
  }), /*#__PURE__*/_react.default.createElement(_Offer.Food, {
    compact: compact,
    food: offer.food,
    foodFullName: offer.foodFullName,
    informationOfCrossTour: offer.isCrossTour ? offer.informationOfCrossTour : undefined,
    isMobile: _reactDeviceDetect.isMobileOnly,
    room: offer.room.name,
    stopsale: offer.stopsale.hotel
  }), /*#__PURE__*/_react.default.createElement(_Offer.Price, {
    compact: compact,
    countryID: hotel.country.id,
    currency: currency,
    departure: offer.departure,
    hotelID: hotelID,
    includes: offer.includes,
    isActual: isIncludedRootOffer,
    isHeightPromo: Boolean(offer.heightPromo),
    isMobile: _reactDeviceDetect.isMobileOnly,
    offerID: offerID,
    operatorID: !compact ? offer.operator : undefined,
    price: offer.price[currency.code],
    promoText: offer.promo || offer.heightPromo || undefined,
    queryID: queryID
  }))), /*#__PURE__*/_react.default.createElement(_PricesMatrix.default, {
    compact: compact,
    country: hotel.country,
    currency: currency,
    hotelID: hotelID,
    offer: offer,
    queriesIDs: queriesIDsForMatrix
  }));
};
Result.propTypes = {
  currency: _propTypes.default.shape({
    code: _propTypes.default.string.isRequired,
    symbol: _propTypes.default.string.isRequired
  }).isRequired,
  hotelID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string.isRequired,
  queryID: _propTypes.default.string.isRequired,
  compact: _propTypes.default.bool,
  position: _propTypes.default.number.isRequired
};
var _default = exports.default = (0, _react.memo)(Result);